import React from 'react';
import { ChipList, Input, Text } from '../../../ui-kit';
import KeywordsField from './components/KeywordsField';
import ReferenceField from './components/ReferenceField';

import '../styles/_specify-context.scss';



































function SpecifyContext({
  aiToolType,
  isDisabled,
  description,
  onChangeDescription,
  keywords,
  onChangeKeywords,
  onRegenerateKeywords,
  tone,
  duration,
  toneList,
  reference,
  referenceLabel,
  onChangeReference,
  durationList,
  onChangeDuration,
  onChangeTone,
  isKeywordsLoading,
  isKeywordGenerating,
  hideTone = false
}) {
  const IDEA_TO_BRIEF = 'IDEA_TO_BRIEF';
  const IDEA_TO_SCRIPT = 'IDEA_TO_SCRIPT';
  const getContextInputLabel = () => {
    switch (aiToolType) {
      case IDEA_TO_BRIEF:
        return 'Describe your project';
      default:
        return 'What do you want AI Compose to write?';
    }
  };

  const getContextInputPlaceholder = () => {
    switch (aiToolType) {
      case IDEA_TO_BRIEF:
        return 'E.g. An internal communications video that summarises our company\'s environmental policy';
      default:
        return 'E.g. Write a brief for an internal communications video, to summarise our company\'s environmental policy.';
    }
  };

  return (
    <div className="specify-context">
      <div className="specify-context--container">
        {reference &&
        <ReferenceField
          isDisabled
          referenceLabel={referenceLabel}
          reference={reference}
          onChangeReference={onChangeReference} />}


        <div className="context-input-label">
          <Input
            multiline
            disabled={isDisabled}
            label={<>{getContextInputLabel()}</>}
            placeholder={getContextInputPlaceholder()}
            value={description}
            defaultValue={description}
            onChange={onChangeDescription}
            rows={4} />

        </div>
        <KeywordsField
          isDisabled={isDisabled}
          isKeywordsLoading={isKeywordsLoading}
          keywords={keywords}
          onChangeKeywords={onChangeKeywords}
          onRegenerateKeywords={onRegenerateKeywords}
          isKeywordGenerating={isKeywordGenerating} />

        {!hideTone &&
        <div>
            <Text className="context-dropdown-label">Tone</Text>
            <ChipList
            isDisabled={isDisabled}
            value={tone}
            data={toneList}
            onSelectItems={onChangeTone}
            borderColorOnSelect="purple"
            bgColorOnSelect="purple25"
            fromChiplist />

          </div>}

        <div>
          <Text className="context-dropdown-label">
            {aiToolType !== IDEA_TO_SCRIPT ? 'Video Duration' : 'Duration'}
          </Text>
          <ChipList
            isDisabled={isDisabled}
            value={duration}
            data={durationList}
            onSelectItems={onChangeDuration}
            borderColorOnSelect="purple"
            bgColorOnSelect="purple25"
            fromChiplist />

        </div>
      </div>
    </div>);

}

SpecifyContext.defaultProps = {
  isDisabled: false,
  isKeywordGenerating: false,
  isKeywordsLoading: false
};

export default SpecifyContext;